import { Contenido } from 'pages/contenido';
import { AppHeader, AppSidebar } from '../../menu';
import { ToastBase } from 'components/toast';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { selectDataToast, selectMessageToast, selectTitleToast, selectTypeToast, selectVisibleToast, setVisibleToast } from 'features/toast/toastBaseSlice';
import { shallowEqual } from 'react-redux';
import React from 'react';

const DashboardAdmin: React.FC = () => {
    const dispatch = useAppDispatch();
    const visible = useAppSelector((state) => selectVisibleToast(state), shallowEqual);
    const color = useAppSelector((state) => selectTypeToast(state), shallowEqual);
    const title = useAppSelector((state) => selectTitleToast(state), shallowEqual);
    const message = useAppSelector((state) => selectMessageToast(state), shallowEqual);
    const data = useAppSelector((state) => selectDataToast(state), shallowEqual);

    return (
        <div>
            <AppSidebar />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <AppHeader />
                <div className="body flex-grow-1 px-3">
                    <ToastBase
                        autohide={false}
                        visible={visible}
                        color={color}
                        message={message}
                        data={data}
                        title={title}
                        onClose={() => { dispatch(setVisibleToast(false)); }}
                    />
                    <Contenido />
                </div>
            </div>
        </div>
    );
};

export { DashboardAdmin };
export default DashboardAdmin;
